module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "chapter",
    attrs: {
      "id": "toc"
    }
  }, [_c('h1', {
    staticClass: "chapter"
  }, [_c('em', [_vm._v("Contents")])]), _vm._v(" "), _c('p', {
    staticClass: "nonindent",
    staticStyle: {
      "margin-bottom": "1em"
    },
    attrs: {
      "id": "deda"
    }
  }, [_c('a', {
    staticClass: "hlink",
    attrs: {
      "href": "#/text/9780062378576_B1_Dedication"
    }
  }, [_vm._v("Dedication")])]), _vm._v(" "), _c('p', {
    staticClass: "nonindent",
    attrs: {
      "id": "pt01a"
    }
  }, [_c('a', {
    staticClass: "hlink",
    attrs: {
      "href": "#/text/9780062378576_B1_Part_1"
    }
  }, [_c('strong', [_vm._v("Part I")])])]), _vm._v(" "), _c('p', {
    staticClass: "nonindent2",
    attrs: {
      "id": "c01a"
    }
  }, [_c('a', {
    staticClass: "hlink",
    attrs: {
      "href": "#/text/9780062378576_B1_Chapter_1"
    }
  }, [_vm._v("1 April Fool")])]), _vm._v(" "), _c('p', {
    staticClass: "nonindent2",
    attrs: {
      "id": "c02a"
    }
  }, [_c('a', {
    staticClass: "hlink",
    attrs: {
      "href": "#/text/9780062378576_B1_Chapter_2"
    }
  }, [_vm._v("2 Umbilical Noose")])]), _vm._v(" "), _c('p', {
    staticClass: "nonindent2",
    attrs: {
      "id": "c03a"
    }
  }, [_c('a', {
    staticClass: "hlink",
    attrs: {
      "href": "#/text/9780062378576_B1_Chapter_3"
    }
  }, [_vm._v("3 Shame Innit?")])]), _vm._v(" "), _c('p', {
    staticClass: "nonindent2",
    attrs: {
      "id": "c04a"
    }
  }, [_c('a', {
    staticClass: "hlink",
    attrs: {
      "href": "#/text/9780062378576_B1_Chapter_4"
    }
  }, [_vm._v("4 Fledgling Hospice")])]), _vm._v(" "), _c('p', {
    staticClass: "nonindent2",
    attrs: {
      "id": "c05a"
    }
  }, [_c('a', {
    staticClass: "hlink",
    attrs: {
      "href": "#/text/9780062378576_B1_Chapter_5"
    }
  }, [_vm._v("5 “Diddle-Di-Diddle-Di”")])]), _vm._v(" "), _c('p', {
    staticClass: "nonindent2",
    attrs: {
      "id": "c06a"
    }
  }, [_c('a', {
    staticClass: "hlink",
    attrs: {
      "href": "#/text/9780062378576_B1_Chapter_6"
    }
  }, [_vm._v("6 How Christmas Should Feel")])]), _vm._v(" "), _c('p', {
    staticClass: "nonindent2",
    attrs: {
      "id": "c07a"
    }
  }, [_c('a', {
    staticClass: "hlink",
    attrs: {
      "href": "#/text/9780062378576_B1_Chapter_7"
    }
  }, [_vm._v("7 One McAvennie")])]), _vm._v(" "), _c('p', {
    staticClass: "nonindent2",
    attrs: {
      "id": "c08a"
    }
  }, [_c('span', {
    staticClass: "hlink",
    attrs: {
      "href": "#/text/9780062378576_B1_Chapter_8",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("8 I’ve Got a Bone to Pick with You")])]), _vm._v(" "), _c('p', {
    staticClass: "nonindent2",
    attrs: {
      "id": "c09a"
    }
  }, [_c('span', {
    staticClass: "hlink",
    attrs: {
      "href": "#/text/9780062378576_B1_Chapter_9",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("9 Teacher’s Whiskey")])]), _vm._v(" "), _c('p', {
    staticClass: "nonindent2",
    attrs: {
      "id": "c10a"
    }
  }, [_c('span', {
    staticClass: "hlink",
    attrs: {
      "href": "#/text/9780062378576_B1_Chapter_10",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("10 “Boobaloo”")])]), _vm._v(" "), _c('p', {
    staticClass: "nonindent2",
    attrs: {
      "id": "c11a"
    }
  }, [_c('span', {
    staticClass: "hlink",
    attrs: {
      "href": "#/text/9780062378576_B1_Chapter_11",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("11 Say Hello to the Bad Guy")])]), _vm._v(" "), _c('p', {
    staticClass: "nonindent",
    attrs: {
      "id": "pt02a"
    }
  }, [_c('span', {
    staticClass: "hlink",
    attrs: {
      "href": "#/text/9780062378576_B1_Part_2",
      "title": "Link target outside of Sample"
    }
  }, [_c('strong', [_vm._v("Part II")])])]), _vm._v(" "), _c('p', {
    staticClass: "nonindent2",
    attrs: {
      "id": "c12a"
    }
  }, [_c('span', {
    staticClass: "hlink",
    attrs: {
      "href": "#/text/9780062378576_B1_Chapter_12",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("12 The Eternal Dilemma")])]), _vm._v(" "), _c('p', {
    staticClass: "nonindent2",
    attrs: {
      "id": "c13a"
    }
  }, [_c('span', {
    staticClass: "hlink",
    attrs: {
      "href": "#/text/9780062378576_B1_Chapter_13",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("13 Body Mist")])]), _vm._v(" "), _c('p', {
    staticClass: "nonindent2",
    attrs: {
      "id": "c14a"
    }
  }, [_c('span', {
    staticClass: "hlink",
    attrs: {
      "href": "#/text/9780062378576_B1_Chapter_14",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("14 Ying Yang")])]), _vm._v(" "), _c('p', {
    staticClass: "nonindent2",
    attrs: {
      "id": "c15a"
    }
  }, [_c('span', {
    staticClass: "hlink",
    attrs: {
      "href": "#/text/9780062378576_B1_Chapter_15",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("15 Click, Clack, Click, Clack")])]), _vm._v(" "), _c('p', {
    staticClass: "nonindent2",
    attrs: {
      "id": "c16a"
    }
  }, [_c('span', {
    staticClass: "hlink",
    attrs: {
      "href": "#/text/9780062378576_B1_Chapter_16",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("16 “Wop Out a Bit of Acting”")])]), _vm._v(" "), _c('p', {
    staticClass: "nonindent2",
    attrs: {
      "id": "c17a"
    }
  }, [_c('span', {
    staticClass: "hlink",
    attrs: {
      "href": "#/text/9780062378576_B1_Chapter_17",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("17 The Stranger")])]), _vm._v(" "), _c('p', {
    staticClass: "nonindent2",
    attrs: {
      "id": "c18a"
    }
  }, [_c('span', {
    staticClass: "hlink",
    attrs: {
      "href": "#/text/9780062378576_B1_Chapter_18",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("18 Is This a Cash Card I See before Me?")])]), _vm._v(" "), _c('p', {
    staticClass: "nonindent2",
    attrs: {
      "id": "c19a"
    }
  }, [_c('span', {
    staticClass: "hlink",
    attrs: {
      "href": "#/text/9780062378576_B1_Chapter_19",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("19 “Do You Want a Drama?”")])]), _vm._v(" "), _c('p', {
    staticClass: "nonindent",
    attrs: {
      "id": "pt03a"
    }
  }, [_c('span', {
    staticClass: "hlink",
    attrs: {
      "href": "#/text/9780062378576_B1_Part_3",
      "title": "Link target outside of Sample"
    }
  }, [_c('strong', [_vm._v("Part III")])])]), _vm._v(" "), _c('p', {
    staticClass: "nonindent2",
    attrs: {
      "id": "c20a"
    }
  }, [_c('span', {
    staticClass: "hlink",
    attrs: {
      "href": "#/text/9780062378576_B1_Chapter_20",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("20 Dagenham Is Not Damascus")])]), _vm._v(" "), _c('p', {
    staticClass: "nonindent2",
    attrs: {
      "id": "c21a"
    }
  }, [_c('span', {
    staticClass: "hlink",
    attrs: {
      "href": "#/text/9780062378576_B1_Chapter_21",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("21 Don’t Die of Ignorance")])]), _vm._v(" "), _c('p', {
    staticClass: "nonindent2",
    attrs: {
      "id": "c22a"
    }
  }, [_c('span', {
    staticClass: "hlink",
    attrs: {
      "href": "#/text/9780062378576_B1_Chapter_22",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("22 Firing Minors")])]), _vm._v(" "), _c('p', {
    staticClass: "nonindent2",
    attrs: {
      "id": "c23a"
    }
  }, [_c('span', {
    staticClass: "hlink",
    attrs: {
      "href": "#/text/9780062378576_B1_Chapter_23",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("23 Down Among the Have-Nots")])]), _vm._v(" "), _c('p', {
    staticClass: "nonindent2",
    attrs: {
      "id": "c24a"
    }
  }, [_c('span', {
    staticClass: "hlink",
    attrs: {
      "href": "#/text/9780062378576_B1_Chapter_24",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("24 First-Class Twit")])]), _vm._v(" "), _c('p', {
    staticClass: "nonindent2",
    attrs: {
      "id": "c25a"
    }
  }, [_c('span', {
    staticClass: "hlink",
    attrs: {
      "href": "#/text/9780062378576_B1_Chapter_25",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("25 Let’s Not Tell Our Mums")])]), _vm._v(" "), _c('p', {
    staticClass: "nonindent2",
    attrs: {
      "id": "c26a"
    }
  }, [_c('span', {
    staticClass: "hlink",
    attrs: {
      "href": "#/text/9780062378576_B1_Chapter_26",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("26 You’re a Diamond")])]), _vm._v(" "), _c('p', {
    staticClass: "nonindent2",
    attrs: {
      "id": "c27a"
    }
  }, [_c('span', {
    staticClass: "hlink",
    attrs: {
      "href": "#/text/9780062378576_B1_Chapter_27",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("27 Call Me Ishmael. Or Isimir. Or Something …")])]), _vm._v(" "), _c('p', {
    staticClass: "nonindent",
    attrs: {
      "id": "pt04a"
    }
  }, [_c('span', {
    staticClass: "hlink",
    attrs: {
      "href": "#/text/9780062378576_B1_Part_4",
      "title": "Link target outside of Sample"
    }
  }, [_c('strong', [_vm._v("Part IV")])])]), _vm._v(" "), _c('p', {
    staticClass: "nonindent2",
    attrs: {
      "id": "c28a"
    }
  }, [_c('span', {
    staticClass: "hlink",
    attrs: {
      "href": "#/text/9780062378576_B1_Chapter_28",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("28 Mustafa Skagfix")])]), _vm._v(" "), _c('p', {
    staticClass: "nonindent2",
    attrs: {
      "id": "c29a"
    }
  }, [_c('span', {
    staticClass: "hlink",
    attrs: {
      "href": "#/text/9780062378576_B1_Chapter_29",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("29 A Gentleman with a Bike")])]), _vm._v(" "), _c('p', {
    staticClass: "nonindent2",
    attrs: {
      "id": "c30a"
    }
  }, [_c('span', {
    staticClass: "hlink",
    attrs: {
      "href": "#/text/9780062378576_B1_Chapter_30",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("30 Out of the Game")])]), _vm._v(" "), _c('p', {
    staticClass: "nonindent2",
    attrs: {
      "id": "c31a"
    }
  }, [_c('span', {
    staticClass: "hlink",
    attrs: {
      "href": "#/text/9780062378576_B1_Chapter_31",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("31 Hare Krishna Morrissey")])]), _vm._v(" "), _c('p', {
    staticClass: "nonindent2",
    staticStyle: {
      "margin-bottom": "1em"
    },
    attrs: {
      "id": "c32a"
    }
  }, [_c('span', {
    staticClass: "hlink",
    attrs: {
      "href": "#/text/9780062378576_B1_Chapter_32",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("32 And Then Three Come at Once")])]), _vm._v(" "), _c('p', {
    staticClass: "nonindent",
    attrs: {
      "id": "atsa"
    }
  }, [_c('span', {
    staticClass: "hlink",
    attrs: {
      "href": "#/text/9780062378576_B1_Authors_Note",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Author’s Note")])]), _vm._v(" "), _c('p', {
    staticClass: "nonindent",
    attrs: {
      "id": "acka"
    }
  }, [_c('span', {
    staticClass: "hlink",
    attrs: {
      "href": "#/text/9780062378576_B1_Acknowledgments",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Acknowledgments")])]), _vm._v(" "), _c('p', {
    staticClass: "nonindent",
    attrs: {
      "id": "ack1a"
    }
  }, [_c('span', {
    staticClass: "hlink",
    attrs: {
      "href": "#/text/9780062378576_B1_Photographic_Acknowledgments",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Photographic Acknowledgments")])]), _vm._v(" "), _c('p', {
    staticClass: "nonindent",
    attrs: {
      "id": "oth"
    }
  }, [_c('span', {
    staticClass: "hlink",
    attrs: {
      "href": "#/text/9780062378576_B1_Others#roth",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Other")])]), _vm._v(" "), _c('p', {
    staticClass: "nonindent",
    attrs: {
      "id": "copa"
    }
  }, [_c('span', {
    staticClass: "hlink",
    attrs: {
      "href": "#/text/9780062378576_B1_Copyright",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Copyright")])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-112dbbc5","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/text/9780062378576_B1_Contents.vue
// module id = 72
// module chunks = 0